var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn-support",attrs:{"to":"/support-form"}},[_vm._v("Solicitar ayuda a un especialista")])}
var staticRenderFns = []

export { render, staticRenderFns }